import React from "react";
import Lottie from "lottie-react";
import animationData from "../../assets/404.json"; 

function NotFound() {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <Lottie 
        animationData={animationData} 
        loop={true} 
        style={{ height: "100%", width: "100%" }} 
      />
    </div>
  );
}

export default NotFound;